import type {
	ClearedFilters,
	CompleteFiltersAppliedClick,
	EmptyStateFilter,
	FiltersAppliedClick,
	SearchHistoryFilterClicked,
	SuggestionFilterClicked
} from '~/types/mixpanel';

import { MixpanelEvents } from '~/core/service/mixpanel';
import { safeTrack } from '~~/utils';

export const useTrackSearchPropertyEvents = () => {
	const trackFiltersCleared = (params: ClearedFilters) => {
		safeTrack(MixpanelEvents.FILTERS_CLEARED, params);
	};

	const trackEmptyStateFilter = (params: EmptyStateFilter) => {
		safeTrack(MixpanelEvents.EMPTY_STATE_FILTER, params);
	};

	const trackSuggestionFilter = (params: SuggestionFilterClicked) => {
		safeTrack(MixpanelEvents.FILTER_BY_SUGGEST, params);
	};

	const trackFilterApplied = (params: CompleteFiltersAppliedClick) => {
		safeTrack(MixpanelEvents.FILTER_APPLIED, params);
	};

	const trackFiltersAppliedResumed = (params: FiltersAppliedClick) => {
		safeTrack(MixpanelEvents.FILTER_APPLIED, params);
	};

	const trackSearchHistoryFilter = (params: SearchHistoryFilterClicked) => {
		safeTrack(MixpanelEvents.SEARCH_HISTORY_FILTER, params);
	};

	return {
		trackSuggestionFilter,
		trackEmptyStateFilter,
		trackFilterApplied,
		trackFiltersAppliedResumed,
		trackFiltersCleared,
		trackSearchHistoryFilter
	};
};
